import { styled } from '@linaria/react';

const HeadingTag = styled.div`
  font-family: 'Figtree-bold';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const ContentTag = styled.div`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export { ContentTag, HeadingTag };
